import { useEffect } from 'react';
import type { useSchedulePreviewParams } from './useSchedulePreviewParams';
import { scheduleDepositToWrite } from './depositMode';
import type { DepositOrigin } from './depositMode';

export function useScheduleDepositWriteBack(options: {
    isReadOnly: boolean;
    isPricingUpdating: boolean;
    depositOrigin: DepositOrigin;
    preview: ReturnType<typeof useSchedulePreviewParams>;
    minDepositMinor: number | undefined;
    effectiveMaxExclusive: number | undefined;
    writeScheduleDeposit: (amountMinor: number) => void;
}): { isDepositWriteBackPending: boolean } {
    const { writeScheduleDeposit, preview } = options;
    const figureMinor = scheduleDepositToWrite({
        isReadOnly: options.isReadOnly,
        origin: options.depositOrigin,
        params: preview.params,
        hasPreview: preview.data !== undefined,
        hasError: preview.error !== null,
        isFetching: preview.isFetching,
        isPlaceholderData: preview.isPlaceholderData,
        isPricingUpdating: options.isPricingUpdating,
        appliedDeposit: preview.appliedDeposit,
        minDepositMinor: options.minDepositMinor,
        effectiveMaxExclusive: options.effectiveMaxExclusive,
    });

    const isBlankEpisode = options.depositOrigin === 'blank';

    useEffect(() => {
        if (isBlankEpisode && figureMinor !== undefined) {
            writeScheduleDeposit(figureMinor);
        }
    }, [isBlankEpisode, figureMinor, writeScheduleDeposit]);

    return { isDepositWriteBackPending: figureMinor !== undefined };
}
